/**
 * Microsoft Clarity session recording user identification.
 * Base script is loaded via GTM; this identifies the authenticated user
 * so session recordings are associated with a known user.
 */

import { logger } from './logger.util'

type ClarityFn = (command: string, ...args: (string | undefined)[]) => void

const getClarity = (): ClarityFn | null => {
  const win = window as Window & { clarity?: ClarityFn }
  return win.clarity ?? null
}

export const identifyClarityUser = (email: string, userId: string): void => {
  const clarity = getClarity()
  if (!clarity) return

  clarity('identify', userId, undefined, undefined, email)

  logger.debug('[Clarity] User identified', userId)
}
